export default "__VITE_ASSET__147a48cf__"